import { http } from "@/http";

// Tipos de cambio por día (DEF-ADM-029). Leer y escribir quedan al mismo
// nivel: SUPER_ADMINISTRATOR y ADMINISTRATOR. El backend lo verifica, acá solo
// se evita ofrecer un botón que devolvería 403.
export default {
  list(params) {
    return http.get("/api/v1/exchange-rates", { params });
  },
  // payload null cuando todavía no hay ninguno cargado: no es un error.
  latest() {
    return http.get("/api/v1/exchange-rates/latest");
  },
  // Si ya existe uno para esa fecha, lo corrige: la fecha es UNIQUE.
  save(data) {
    return http.post("/api/v1/exchange-rates", data);
  },
  update(id, data) {
    return http.put(`/api/v1/exchange-rates/${id}`, data);
  },
};
